export const getScheme = () => {
    const storageScheme = localStorage.getItem('color-scheme');
    if (storageScheme) {
        return storageScheme === 'dark' ? 'dark' : 'light';
    }
    else if (document.documentElement.classList.contains('dark')) {
        return 'dark';
    }
    else if (document.documentElement.classList.contains('light')) {
        return 'light';
    }
    return 'auto';
};
export const isDarkScheme = () => getScheme() === 'dark';
export const setScheme = (scheme) => {
    document.documentElement.classList.remove('light', 'dark');
    if (scheme === 'auto') {
        localStorage.removeItem('color-scheme');
    }
    else {
        localStorage.setItem('color-scheme', scheme);
        document.documentElement.classList.add(scheme);
    }
};
